import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import WhyUs from "./components/WhyUs";
import Portfolio from "./components/Portfolio";
import Process from "./components/Process";
import Clients from "./components/Clients";
import Certifications from "./components/Certifications";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import JsonLd from "@/components/base/JsonLd";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "GeneralContractor",
  "name": "제이아이앤씨",
  "alternateName": "JI&C",
  "url": import.meta.env.VITE_SITE_URL,
  "logo": "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/b541ae47-1bf4-433d-8cc6-b0741de80222_compressed_-1.webp",
  "description": "2010년 설립된 전문건설업체로 에폭시 바닥공사, 우레탄 방수, 도장, 실내건축, 석공사 분야에서 400건 이상의 시공 실적을 보유한 부산 소재 건설회사입니다.",
  "foundingDate": "2010-05-01",
  "founder": {
    "@type": "Person",
    "name": "김승현"
  },
  "telephone": "+82-51-727-0477",
  "email": "ksh10090000@hanmail.net",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "장안읍 좌천로 20, 101호",
    "addressLocality": "부산광역시",
    "addressRegion": "기장군",
    "postalCode": "46008",
    "addressCountry": "KR"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "35.3107",
    "longitude": "129.2425"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "09:00",
    "closes": "18:00"
  },
  "areaServed": ["부산광역시", "울산광역시", "경상남도", "경상북도"],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "시공 서비스",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "에폭시 바닥공사" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "우레탄 방수" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "외벽도장" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "내부도장" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "실내건축" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "석공사" } }
    ]
  },
  "knowsAbout": ["에폭시바닥", "우레탄방수", "도장공사", "습식방수", "석공사", "실내건축", "페인트 제조"],
  "slogan": "신뢰를 시공하는 전문건설업체",
  "sameAs": [
    "https://blog.naver.com/ksh1009000",
    "https://pf.kakao.com/_exaxmSn"
  ]
};

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "제이아이앤씨 JI&C",
  "url": import.meta.env.VITE_SITE_URL,
  "description": "전문건설업체 제이아이앤씨 공식 홈페이지. 에폭시 바닥공사, 우레탄 방수, 도장, 실내건축, 석공사 시공사례 및 견적문의.",
  "inLanguage": "ko",
  "publisher": {
    "@type": "Organization",
    "name": "제이아이앤씨",
    "url": import.meta.env.VITE_SITE_URL,
    "logo": "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/b541ae47-1bf4-433d-8cc6-b0741de80222_compressed_-1.webp"
  }
};

export default function Home() {
  return (
    <>
      <JsonLd data={localBusinessSchema} />
      <JsonLd data={webSiteSchema} />
      <div className="w-full bg-white text-navy-900">
        <Navbar />
        <main>
          <div id="top"></div>
          <Hero />
          <About />
          <Services />
          <WhyUs />
          <Portfolio />
          <Process />
          <Clients />
          <Certifications />
          <Blog />
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
}